import { Component, input, InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { Payout, PayoutStatus } from 'src/app/models/payout.model';

@Component({
  selector: 'app-organizer-payouts-table',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatChipsModule],
  templateUrl: './organizer-payouts-table.component.html',
  styleUrl: './organizer-payouts-table.component.scss',
})
export class OrganizerPayoutsTableComponent {
  payouts: InputSignal<Payout[]> = input.required<Payout[]>();
  displayedColumns: string[] = ['amount', 'status', 'createdAt', 'updatedAt'];

  protected getStatusLabel(status: PayoutStatus): string {
    switch (status) {
      case PayoutStatus.REQUESTED:
        return 'Requested';
      case PayoutStatus.SENT_FOR_PAYMENT:
        return 'Sent for Payment';
      case PayoutStatus.PAID:
        return 'Paid';
      case PayoutStatus.CANCELLED:
        return 'Cancelled';
      default:
        return status;
    }
  }
}
